import { EndorsementMemberStatusEnum } from '@/types';
import React from 'react';
import { CheckCircle, InfoIcon, PendingClock } from 'ui/icons';

// Props interface for StatusCard
interface IStatusCardProps {
  status: EndorsementMemberStatusEnum;
}

// StatusCard component
const StatusCard: React.FC<IStatusCardProps> = ({ status }) => {
  // Render different card content based on the status prop
  const renderCardContent = () => {
    switch (status) {
      case EndorsementMemberStatusEnum.Pending:
        return (
          <div className="py-1 px-2 rounded-lg flex items-center border-[1px] border-secondary-600 bg-secondary-50 gap-1">
            <PendingClock className="w-4 h-4" />
            <p className="text-sm text-secondary-800 font-semibold">
              Addition Pending
            </p>
          </div>
        );
      case EndorsementMemberStatusEnum.Failed:
        return (
          <div className="py-1 px-2 rounded-lg flex items-center border-[1px] border-primary-700 bg-primary-50 gap-1">
            <InfoIcon fill={'#8f2f38'} className="w-4 h-4" />
            <p className="text-sm text-primary-700 font-semibold">Failed</p>
          </div>
        );
      case EndorsementMemberStatusEnum.Approved:
        return (
          <div className="py-1 px-2 rounded-lg flex items-center border-[1px] border-teal-600 bg-teal-50 gap-1">
            <CheckCircle
              stroke="#41797A"
              fill="none"
              strokeWidth={2}
              className="w-4 h-4"
            />
            <p className="text-sm text-teal-700 font-semibold">
              Addition Completed
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return <div>{renderCardContent()}</div>;
};

export default StatusCard;
